/**
 * Tone vocabulary mirrors the rest of the package (StatusPill, ModeBadge,
 * ConfirmDialog) so callers don't need to learn a new palette.
 *
 *   - `info`    new feature, tip, FYI announcement (default)
 *   - `success` celebratory ack (you upgraded! you completed onboarding!)
 *   - `caution` heads-up that needs attention but isn't blocking
 *   - `error`   non-blocking error report (failed background sync, etc.)
 *   - `promo`   marketing surface, distinct primary tint — for plan
 *               upgrade banners and similar growth surfaces
 */
export const PROMO_BANNER_TONE_INFO = 'info';
export const PROMO_BANNER_TONE_SUCCESS = 'success';
export const PROMO_BANNER_TONE_CAUTION = 'caution';
export const PROMO_BANNER_TONE_ERROR = 'error';
export const PROMO_BANNER_TONE_PROMO = 'promo';

export type PromoBannerTone =
  | typeof PROMO_BANNER_TONE_INFO
  | typeof PROMO_BANNER_TONE_SUCCESS
  | typeof PROMO_BANNER_TONE_CAUTION
  | typeof PROMO_BANNER_TONE_ERROR
  | typeof PROMO_BANNER_TONE_PROMO;

/**
 * Visual treatment.
 *   - `subtle` (default) tinted background + matching foreground; sits
 *     comfortably inside any page surface without dominating
 *   - `prominent` filled background; for top-of-page announcements that
 *     should claim the user's first glance
 */
export const PROMO_BANNER_VARIANT_SUBTLE = 'subtle';
export const PROMO_BANNER_VARIANT_PROMINENT = 'prominent';

export type PromoBannerVariant =
  | typeof PROMO_BANNER_VARIANT_SUBTLE
  | typeof PROMO_BANNER_VARIANT_PROMINENT;

/** `compact` keeps the message and its actions on one wrapping row, for inline notices. */
export const PROMO_BANNER_DENSITY_REGULAR = 'regular';
export const PROMO_BANNER_DENSITY_COMPACT = 'compact';

export type PromoBannerDensity =
  | typeof PROMO_BANNER_DENSITY_REGULAR
  | typeof PROMO_BANNER_DENSITY_COMPACT;
